import { DefaultTheme, StyleSheetManager, ThemeProvider as V1ThemeProvider } from "styled-components";
import { ThemeProvider as DitThemeProvider, ThemeStructure } from "@dit/ui-components.react.theme";
import { GlobalStyle } from "@app/styles/globalStyle";
import { FC, PropsWithChildren, use } from "react";

// ensures styled-components injects CSS into a predictable location, after vendor CSS
const styledComponentsTarget = document.getElementById("styled-components-target") as HTMLStyleElement | null;

interface ApplicationThemeProviderProps {
    themesPromise: Promise<{ v1Theme: DefaultTheme; ditTheme: ThemeStructure }>;
}

export const ApplicationThemeProvider: FC<PropsWithChildren<ApplicationThemeProviderProps>> = ({
    themesPromise,
    children,
}) => {
    const { v1Theme, ditTheme } = use(themesPromise);
    return (
        <DitThemeProvider defaultMode="light" theme={ditTheme}>
            <StyleSheetManager target={styledComponentsTarget}>
                <V1ThemeProvider theme={v1Theme}>
                    <GlobalStyle theme={v1Theme} />
                    {children}
                </V1ThemeProvider>
            </StyleSheetManager>
        </DitThemeProvider>
    );
};
